"use client";

import { Button } from "@/core/components/ui/button";
import { BetaTag } from "./beta-tag";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/core/components/ui/dropdown-menu";
import { Menu, MoreVertical, SquarePen, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { HeaderAgentIcon } from "../constants/agents";
import { ChatWindowHeaderTypes } from "../types";

export function ChatWindowHeader({
  onClose,
  onGripMouseDown,
  showDragHandle = false,
  onNewConversation,
  isHistoryOpen,
  onOpenHistory,
  onCloseHistory,
}: ChatWindowHeaderTypes) {
  const [translate] = useTranslation(["core"]);

  return (
    <div className="flex items-center justify-between px-[24px] py-[32px] text-darkgray-700 rounded-t-[64px] flex-shrink-0 bg-white border-b">
      <div className="flex gap-2 items-center">
        {/* {showDragHandle && onGripMouseDown && (
          <button
            type="button"
            onMouseDown={onGripMouseDown}
            className="flex justify-center items-center mr-1 text-darkgray-200 cursor-grab active:cursor-grabbing touch-none"
            aria-label={translate("chatbot-aria-drag-window") as string}
          >
            <GripVertical className="w-5 h-5" strokeWidth={2} />
          </button>
        )} */}
        <img
          src={HeaderAgentIcon}
          alt=""
          aria-hidden
          className="object-contain w-[40px] h-[40px]"
        />
        <div className="flex items-center gap-2">
          <h3 className="text-[16px] font-semibold text-darkgray-700">
            <span>{translate("chatbot-title-facilities-prefix")}</span>{" "}
            <i className="font-serif italic text-[17px]">
              {translate("chatbot-title-facilities-emphasis")}
            </i>{" "}
            <span>{translate("chatbot-title-facilities-suffix")}</span>
          </h3>
          <BetaTag />
        </div>
      </div>
      <div className="flex gap-1 items-center">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              size="sm"
              className="p-0 w-8 h-8 text-darkgray-600 hover:bg-lightgray-200"
              aria-label={translate("chatbot-aria-actions-menu") as string}
            >
              <MoreVertical className="w-5 h-5" strokeWidth={1} />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="z-[1000000] w-56">
            <DropdownMenuItem onClick={onNewConversation}>
              <SquarePen className="mr-2 w-4 h-4" />
              {translate("chatbot-history-new-conversation")}
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={isHistoryOpen ? onCloseHistory : onOpenHistory}
            >
              <Menu className="mr-2 w-4 h-4" />
              {translate(
                isHistoryOpen
                  ? "chatbot-history-close"
                  : "chatbot-history-open",
              )}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>

        <Button
          variant="ghost"
          size="sm"
          onClick={onClose}
          className="p-0 w-8 h-8 text-darkgray-600 hover:bg-lightgray-200"
          aria-label={translate("chatbot-aria-close-chat") as string}
        >
          <X className="w-6 h-6" strokeWidth={1} />
        </Button>
      </div>
    </div>
  );
}
